<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>Создать банер</strong>
                </CCardHeader>
                <CCardBody>
                    <BannerUpsertForm @success="$router.push(`/banners`)" />
                </CCardBody>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import BannerUpsertForm from '@/components/banners/BannerUpsertForm';

    export default {
        name: 'BannerCreate',

        components: {
            BannerUpsertForm,
        },
    };
</script>
